export default __webpack_public_path__ + "static/media/prod5.af89df89.jpg";